import type { LoomBooleanConstructionTrace } from "../../api/loomRebuildConstructionTrace";
import type { LoomRebuildPhase } from "../../api/loomRebuild";

function phaseLabel(phase: LoomRebuildPhase | null): string {
  if (phase === "implicit_guided_trimming") return "Refining the wing–body join";
  if (phase === "panelization_qc" || phase === "packing_verification") {
    return "Join located · rebuilding the surrounding surface";
  }
  return "Checking the reconstructed join";
}

export function LoomBooleanConstructionTraceEvidence({
  phase,
  trace,
}: {
  phase: LoomRebuildPhase | null;
  trace: LoomBooleanConstructionTrace | null;
}) {
  if (!trace) return null;
  const maximumUncertaintyM = Math.max(...trace.seams.flatMap((seam) => seam.uncertainty_radius_m));
  return (
    <aside
      aria-label="Boolean construction progress"
      aria-live="polite"
      className="loom-boolean-construction-trace"
      data-authority={trace.authority}
      data-last-accepted-visible="true"
      data-maximum-uncertainty-m={maximumUncertaintyM}
      data-seam-count={trace.seams.length}
      data-testid="loom-boolean-construction-trace"
      data-uncertainty-display="screen-enlarged-bounded"
    >
      <strong>{phaseLabel(phase)}</strong>
      <span><i className="is-uncertain" />Uncertain search band</span>
      <span><i className="is-corrected" />Corrected join</span>
      <small>Uncertainty enlarged for visibility · seam position remains exact</small>
    </aside>
  );
}
